export default "__VITE_ASSET__BDe2Wxyb__"